export default __webpack_public_path__ + "static/media/DIJKInfo.5ca8b667.md";